<template>
  <div>
    <h5>
      <strong>{{ $t("name") }}:</strong> {{ title }}
      <span class="ml-5" v-if="supervisor"
        ><strong> Supervisor:</strong> {{ supervisor.username }}</span
      >
    </h5>
    <v-divider />
    <form>
      <SelectPeopleList
        :disabled-form="true"
        :items-selected="personsInCharge"
      />
      <v-divider />
      <DirectorActions v-if="isAuthorize" :object_type="object_type" />
      <SupervisorActions
        v-else
        :item="investigator"
        :object_type="object_type"
        :form_name="form_name"
        :state="state"
        :supervisor="supervisor !== null ? supervisor.username : ''"
        @change-state-supervisor="onStateSupervisorChange"
      />
    </form>
  </div>
</template>

<script>
import SelectPeopleList from "../../reusables/SelectPeopleList";
import DirectorActions from "../../action_buttons/DirectorActions";
import SupervisorActions from "../../action_buttons/SupervisorActions";
import axios from "axios";
import investigatorData from "../../../mixins/investigator_data";
export default {
  mixins: [investigatorData],
  components: { SelectPeopleList, SupervisorActions, DirectorActions },
  name: "ReviewModifyResponsible",

  created() {
    this.getData();
  },

  data: () => ({
    menu: false,
    object_type: "",
    state: "",
    title: "",
    reject_comment: "",
    supervisor: "",
    form_name: ""
  }),

  computed: {
    isAuthorize() {
      return this.$route.meta.authorize !== undefined;
    }
  },
  methods: {
    getData() {
      let path;
      if (this.isAuthorize) {
        path =
          this.$store.state.endpoint +
          "/direction/moderatedOperations/authorize/investigator/" +
          this.$route.params.id;
      } else {
        path =
          this.$store.state.endpoint +
          "/moderatedOperations/review/investigator/" +
          this.$route.params.id;
      }
      axios
        .get(path)
        .then(response => {
          this.personsInCharge = response.data.data.user.person.incharge;
          this.reject_comment = response.data.reject_comment;
          this.form_name = response.data.form_name;
          this.title = response.data.title;
          this.state = response.data.state;
          this.supervisor = response.data.supervisor;
          this.object_type = response.data.object_type;
          this.investigator.id = response.data.object_id;
          this.getInvestigator(
            this.$store.state.endpoint + "/person/" + this.investigator.id
          );
        })
        .catch(error => {
          console.log(error);
        });
    },

    onStateSupervisorChange(state, supervisor) {
      this.state = state;
      this.supervisor = supervisor;
    }
  }
};
</script>

<style scoped></style>
